import { Box, Heading, Image, List, Paragraph } from '@zillow/constellation-10';
import { useTermSet } from '../../../IdvContext';
import { TermSet } from '../../../../../models';
import verifyLight from '../../../images/verify-light.svg';

const verifyLightSrc = verifyLight.src;

function LandlordContent() {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
      <Box aria-hidden="true" css={{ marginBottom: 'default' }}>
        <Image src={verifyLightSrc} alt="Verify your identity" width={120} height={120} />
      </Box>
      <Heading level={2} textStyle="heading-sm">
        Verify your identity to view applications
      </Heading>
      <Paragraph>
        To protect applicants’ confidential information, the Fair Credit Reporting Act requires that we make sure it’s
        really you.
      </Paragraph>
      <Paragraph>You’ll be asked:</Paragraph>
      <List.Root appearance="bullet">
        <List.Item>Your full legal name and current address</List.Item>
        <List.Item>Your Social Security number (optional)</List.Item>
        <List.Item>Consent for Experian’s and CIC’s terms and conditions</List.Item>
        <List.Item>Additional security questions that Experian uses to confirm your identity</List.Item>
      </List.Root>
      <Paragraph>Once completed, your verification will be valid for 335 days.</Paragraph>
    </Box>
  );
}

function RenterContent() {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
      <Box aria-hidden="true" css={{ marginBottom: 'default' }}>
        <Image src={verifyLightSrc} alt="Verify your identity" width={120} height={120} />
      </Box>
      <Heading level={2} textStyle="heading-sm">
        Verify your identity
      </Heading>
      <Paragraph>
        The information collection in this step is used to verify your identity. This helps ensure that your credit
        history and background report are accurate, secure, and protected. These reports are only shared with rental
        managers who have also verified their identities.
      </Paragraph>
      <Paragraph>You’ll be asked to provide:</Paragraph>
      <List.Root appearance="bullet">
        <List.Item>Your full legal name, current address, and mobile phone number</List.Item>
        <List.Item>Your date of birth</List.Item>
        <List.Item>Your Social Security number or ITIN (optional)</List.Item>
        <List.Item>
          Consent to terms from Experian and Contemporary Information Corp. (CIC) to perform credit and background
          checks
        </List.Item>
      </List.Root>
      <Paragraph>Experian may also ask additional security questions to help confirm your identity.</Paragraph>
    </Box>
  );
}

export default function LandingStep() {
  const termSet = useTermSet();

  return <>{termSet === TermSet.LandlordScreening ? <LandlordContent /> : <RenterContent />}</>;
}
